<template>
  <div class="ci-alert">
    <h1>您没有权限访问这个界面</h1>
    <h1>请联系管理员以获得此权限</h1>
  </div>
</template>

<script>
export default {
  name: 'noAccess'
}
</script>



// WEBPACK FOOTER //
// noAccess.vue?37b6acbb